module.exports = __webpack_public_path__ + "img/diagram-rectangle.c168914f.svg";